export default __webpack_public_path__ + "static/media/previous_children.28b595ed.png";